import React from 'react';
import { connect } from 'react-redux';
import LocationField from '../../shared/LocationField';
import RepeatSectionFields from '../../shared/RepeatSectionFields';
import TimeRangeFields from '../../shared/TimeRangeFields';
import SlotRestrictionsFields from '../../shared/SlotRestrictionsFields';
import HForm, { ToggleSwitchField } from 'shared/containers/portal_layout/HForm';
import { reduxForm, formValueSelector } from 'utils/reduxFormWrapper';
import classes from './EditSlotForm.module.scss';
import { createValidator, required } from 'utils/validation';
import SpinnerButton from 'shared/components/SpinnerButton';
import PromiseButton from 'shared/components/PromiseButton';

const validateForm = createValidator({
  locationId: required,
});

const REPEAT_SECTION_FEATURE_FLAG = false;

const editSlotFormSelector = formValueSelector('editSlot');
function editSlotFormMapStateToProps(state) {
  const locations = state.calendar.providerEmployments.find(
    pe => pe.providerEmploymentId === state.calendar.selectedProviderEmploymentId
  ).locations;
  return {
    showRepeatSection: editSlotFormSelector(state, 'repeat') && REPEAT_SECTION_FEATURE_FLAG, // TODO: make repeat section
    locationOptions: locations.map(l => ({ value: l.id, label: l.name })),
  };
}
const EditSlotForm = connect(editSlotFormMapStateToProps)(
  ({
    selectionStart,
    selectionEnd,
    showRepeatSection,
    handleSubmit,
    onDestroyClick,
    submitting,
    onUpdateSlot,
    locationOptions,
    selectedLocationId,
  }) => (
    <HForm onSubmit={handleSubmit(onUpdateSlot)}>
      <LocationField options={locationOptions} value={selectedLocationId} />
      <div style={{ textAlign: 'center', margin: '20px 0' }}>
        <TimeRangeFields selectionStart={selectionStart} selectionEnd={selectionEnd} />
      </div>

      {REPEAT_SECTION_FEATURE_FLAG && (
        <ToggleSwitchField
          name="repeat"
          label="Repeat?"
          showStateLabel
          onStateLabel="Yes"
          offStateLabel="No"
        />
      )}

      {showRepeatSection && (
        <RepeatSectionFields
          formValueSelector={editSlotFormSelector}
          selectionStart={selectionStart}
        />
      )}

      <SlotRestrictionsFields />

      <div className={classes.form_actions}>
        <PromiseButton
          type="button"
          className="button is-danger"
          disabled={submitting}
          onClick={onDestroyClick}
        >
          Delete Slot
        </PromiseButton>
        <SpinnerButton className="button is-link" type="submit" loading={submitting}>
          Update Slot
        </SpinnerButton>
      </div>
    </HForm>
  )
);

EditSlotForm.displayName = 'EditSlotForm';

export default reduxForm({
  form: 'editSlotForm',
  validate: validateForm,
})(EditSlotForm);
